<template>
  <div class="dashboard-container">
    <div class="top-option-container">
      <div class="top-list-container">
        <div class="label-top-list">
          <label>Period</label>
        </div>
        <b-form-select
          :options="yearGenerate"
          v-model="yearFrom"
          class="top-list-menu"
        ></b-form-select>
        <b-form-select
          :options="monthGenerate"
          v-model="monthFrom"
          class="top-list-menu"
        ></b-form-select>
        <b-form-select
          :options="yearGenerate"
          v-model="yearTo"
          class="top-list-menu"
        ></b-form-select>
        <b-form-select
          :options="monthGenerate"
          v-model="monthTo"
          class="top-list-menu"
        ></b-form-select>
      </div>
      <b-button
        @click="getCsiData"
        :disabled="yearFrom <= yearTo ? false : true"
      >
        Submit
      </b-button>
      <b-button
        @click="$router.push('/dashboarddetailcsi', () => {})"
        class="ml-2"
        :disabled="$store.state.csiDashboardDetail ? false : true"
      >
        Detail
      </b-button>
    </div>
    <div class="spm-chart-container">
      <CsiCompany v-if="renderComp" />
      <CsiSummary v-if="renderComp" />
    </div>
    <div class="loading-dashboard" v-if="isLoading">
      <b-spinner
        variant="primary"
        label="Spinning"
        class="loading-spinner"
      ></b-spinner>
    </div>
  </div>
</template>
<script>
import { api } from '../services/config'
import axios from 'axios'
import CsiCompany from '@/components/dashboard/csi-company.vue'
import CsiSummary from '@/components/dashboard/csi-summary.vue'
export default {
  name: 'csiDashboard',
  components: {
    CsiCompany,
    CsiSummary,
  },
  data() {
    return {
      renderComp: true,
      isLoading: false,
      yearFrom: new Date().getFullYear() - 1,
      monthFrom: 1,
      yearTo: new Date().getFullYear(),
      monthTo: 1,
      csiData: [],
      summaryData: [],
    }
  },
  created() {
    const self = this
    self.$store.dispatch('toggleSidebar', false)
    self.yearGenerate
  },
  computed: {
    checkSpm: {
      get: function() {
        return this.spmData
      },
    },
    checkSummary: {
      get: function() {
        return this.summaryData
      },
    },
    yearGenerate: {
      get: function() {
        let currentYear = new Date().getFullYear()
        let totalYear = currentYear - 2010
        let year = []
        for (let i = 0; i <= totalYear; i++) {
          year.push(currentYear - i)
        }
        return year
      },
    },
    monthGenerate: {
      get: function() {
        let month = [
          { value: 1, text: 'Jan' },
          { value: 2, text: 'Feb' },
          { value: 3, text: 'Mar' },
          { value: 4, text: 'Apr' },
          { value: 5, text: 'Mei' },
          { value: 6, text: 'Jun' },
          { value: 7, text: 'Jul' },
          { value: 8, text: 'Agt' },
          { value: 9, text: 'Sep' },
          { value: 10, text: 'Oct' },
          { value: 11, text: 'Nov' },
          { value: 12, text: 'Des' },
        ]
        return month
      },
    },
  },
  methods: {
    reRender() {
      this.renderComp = false

      this.$nextTick(() => {
        this.renderComp = true
      })
    },
    stopLoading() {
      this.isLoading = false
    },
    runLoading() {
      this.isLoading = true
    },
    async getCsiData() {
      try {
        if (this.yearFrom <= this.yearTo) {
          this.$ga.event({
            eventCategory: 'Dashboard CSI',
            eventAction: 'click',
            eventLabel: `SUBMIT PERIOD_YEAR_FROM=${this.yearFrom}&PERIOD_MONTH_FROM=${this.monthFrom}&PERIOD_YEAR_TO=${this.yearTo}&PERIOD_MONTH_TO=${this.monthTo}`,
          })
          await this.runLoading()
          const uri = `${api}/api/v1/dashboard/csi?PERIOD_YEAR_FROM=${this.yearFrom}&PERIOD_MONTH_FROM=${this.monthFrom}&PERIOD_YEAR_TO=${this.yearTo}&PERIOD_MONTH_TO=${this.monthTo}`
          const { data } = await axios({
            method: 'GET',
            url: uri,
          })
          if (data && data.status == 'success' && data.data) {
            this.csiData = global
            const csiData = {
              csiDetail: data.data.detail,
              csiCompany: data.data.global,
              csiSummary: data.data.summary,
              csiYearFrom: this.yearFrom,
              csiMonthFrom: this.MonthFrom,
              csiYearTo: this.yearTo,
              csiMonthTo: this.MonthTo,
            }
            await this.$store.commit('SET_CSI_DASHBOARD', csiData)
            await this.reRender()
            await this.stopLoading()
          } else {
            const csiData = {
              csiDetail: null,
              csiCompany: null,
              csiSummary: null,
              csiYearFrom: null,
              csiMonthFrom: null,
              csiYearTo: null,
              csiMonthTo: null,
            }
            await this.$store.commit('SET_CSI_DASHBOARD', csiData)
            await this.stopLoading()
          }
        }
      } catch (error) {
        this.stopLoading()
      }
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/components/dashboard.scss';
</style>
